import ThisModule from "./AlertBox";

export default ThisModule;
